import { type Id, toast, type ToastOptions } from "react-toastify";
import { ToastView } from "./ToastView";
import type { ToastProps, ToastVariant } from "./types";

const roleMap: Record<ToastVariant, "status" | "alert"> = {
  info: "status",
  success: "status",
  warning: "alert",
  error: "alert",
};

const defaultDurations: Record<ToastVariant, number> = {
  info: 5000,
  success: 5000,
  warning: 5000,
  error: 5000,
};

function push(variant: ToastVariant, opts: ToastProps, c?: ToastOptions) {
  const { title, text, action, duration, ariaLabel, role } = opts;

  return toast(
    ({ closeToast }) => {
      return (
        <ToastView
          variant={variant}
          title={title}
          text={text}
          action={action}
          onClose={closeToast}
        />
      );
    },
    {
      ...c,
      autoClose: duration ?? defaultDurations[variant],
      role: role ?? roleMap[variant],
      ariaLabel,
    } as ToastOptions,
  );
}

export const Toast = {
  info: (o: ToastProps, c?: ToastOptions) => push("info", o, c),
  success: (o: ToastProps, c?: ToastOptions) => push("success", o, c),
  warning: (o: ToastProps, c?: ToastOptions) => push("warning", o, c),
  error: (o: ToastProps, c?: ToastOptions) => push("error", o, c),

  promise: toast.promise,
  update: toast.update,
  dismiss: (id?: Id) => toast.dismiss(id),
  clearAll: () => toast.dismiss(),
} as const;
